import {
  base_colorContentBorder,
  base_contentBackground,
  tag_colorTagNewText,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import React from 'react'
import AiSparkle from 'src/assets/svgs/AI-sparkle.svg'
import ReceiptAgentExtendLogo from 'src/assets/svgs/ReceiptAgentExtendLogo.svg'
import { css } from 'styled-components'

interface ReceiptAgentAvatarProps {
  className?: string
  testId?: string
}

const style = css`
  position: relative;
  display: inline-block;
  flex: none;
  width: ${spacing(6)};
  height: ${spacing(6)};

  &::before {
    position: absolute;
    inset: 0;
    box-sizing: border-box;
    border: 1px solid ${base_colorContentBorder};
    border-radius: 50%;
    background: #1e2c4c;
    content: '';
  }

  > img {
    position: absolute;
    top: ${spacing(1.5)};
    left: ${spacing(1.5)};
    display: block;
    width: ${spacing(3)};
    height: ${spacing(3)};
  }

  > span {
    position: absolute;
    top: 15.3312px;
    left: 15.3313px;
    display: flex;
    width: 10.08px;
    height: 10.08px;
    padding: 1.008px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    border-radius: 10.08px;
    background: ${tag_colorTagNewText};
    box-shadow: 0 0 0 1px ${base_contentBackground};
  }

  > span > img {
    display: block;
    flex-shrink: 0;
    width: 8.064px;
    height: 8.064px;
    max-width: none;
    filter: brightness(0) invert(1);
  }
`

const ReceiptAgentAvatar = ({
  className,
  testId = 'receipt-agent-avatar',
}: ReceiptAgentAvatarProps): React.ReactElement => {
  const avatarClassName = className ?? 'ReceiptAgentAvatar'

  return (
    <span
      css={style}
      className={avatarClassName}
      data-testid={testId}
      aria-hidden
    >
      <img
        className={`${avatarClassName}-logo`}
        src={ReceiptAgentExtendLogo}
        alt={''}
      />
      <span className={`${avatarClassName}-sparkle`}>
        <img src={AiSparkle} alt={''} />
      </span>
    </span>
  )
}

export default ReceiptAgentAvatar
